var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-input',_vm._b({attrs:{"value":_vm.displayValue},on:{"input":_vm.onInput,"blur":_vm.onBlur}},'a-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }